import { render } from "./ShowDeal.vue?vue&type=template&id=40b959a9"
import script from "./ShowDeal.vue?vue&type=script&lang=js"
export * from "./ShowDeal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__